(() => {
  // Delegate to the live input so controls survive theme/editor DOM updates.
  if (!window.cpQuantityEventsInstalled) {
    window.cpQuantityEventsInstalled = true;
    document.addEventListener('click', (event) => {
      const button = event.target.closest?.('[data-cp-product] [data-cp-qty]');
      if (!button) return;
      const input = button.closest('.cp-quantity')?.querySelector('input[name="quantity"]');
      if (!input) return;
      event.preventDefault();
      event.stopPropagation();
      const minimum = Number(input.min) || 1;
      const maximum = input.max ? Number(input.max) : Infinity;
      input.value = String(Math.min(maximum, Math.max(minimum, (parseInt(input.value, 10) || minimum) + Number(button.dataset.cpQty))));
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }, true);
    document.addEventListener('change', (event) => {
      const input = event.target;
      if (!input.matches?.('[data-cp-product] .cp-quantity input')) return;
      input.value = String(Math.min(input.max ? Number(input.max) : Infinity, Math.max(Number(input.min) || 1, parseInt(input.value, 10) || 1)));
    }, true);
  }
  function setupProduct(section) {
    if (section.dataset.cpReady === 'true') return;
    section.dataset.cpReady = 'true';

    const image = section.querySelector('.cp-gallery__image');
    const thumbs = [...section.querySelectorAll('[data-cp-thumb]')];
    const rail = section.querySelector('[data-cp-thumbs]');
    let activeIndex = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('is-active')));

    function showImage(index) {
      if (!image || thumbs.length === 0) return;
      activeIndex = (index + thumbs.length) % thumbs.length;
      const thumb = thumbs[activeIndex];
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = thumb.dataset.cpImage;
      image.alt = thumb.dataset.cpAlt || thumb.querySelector('img')?.alt || '';
      thumbs.forEach((button, buttonIndex) => {
        button.classList.toggle('is-active', buttonIndex === activeIndex);
        if (buttonIndex === activeIndex) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });
      if (rail) {
        if (window.matchMedia('(max-width: 749px)').matches) rail.scrollTo({ left: thumb.offsetLeft - rail.offsetLeft - 8, behavior: 'smooth' });
        else rail.scrollTo({ top: thumb.offsetTop - rail.offsetTop - 8, behavior: 'smooth' });
      }
    }
    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => showImage(index)));
    section.querySelectorAll('[data-cp-gallery-step]').forEach((button) => button.addEventListener('click', () => showImage(activeIndex + Number(button.dataset.cpGalleryStep))));
    section.querySelectorAll('[data-cp-rail-step]').forEach((button) => button.addEventListener('click', () => {
      if (!rail) return;
      const step = Number(button.dataset.cpRailStep) * 105;
      rail.scrollBy(window.matchMedia('(max-width: 749px)').matches ? { left: step, behavior: 'smooth' } : { top: step, behavior: 'smooth' });
    }));

    let variants = [];
    try { variants = JSON.parse(section.querySelector('[data-cp-variants]')?.textContent || '[]'); } catch (_) { variants = []; }
    const money = (cents) => {
      const currency = section.dataset.currency || 'GBP';
      try { return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency }).format(Number(cents) / 100); }
      catch (_) { return `£${(Number(cents) / 100).toFixed(2)}`; }
    };
    const optionControls = [...section.querySelectorAll('[data-cp-option], [data-cp-extra-option]')];
    function readChoices() {
      const choices = [];
      optionControls.filter((control) => control.type !== 'radio' || control.checked).forEach((control) => {
        choices[Number(control.dataset.cpOptionIndex)] = control.value;
      });
      return choices;
    }
    function variantForChoices(choices, changedIndex) {
      const exact = variants.find((candidate) => candidate.options.every((value, index) => value === choices[index]));
      if (Number.isInteger(changedIndex) && changedIndex < choices.length - 1 && !exact?.available) {
        return variants.find((candidate) => candidate.available && candidate.options.every((value, index) => index > changedIndex || value === choices[index])) || exact;
      }
      return exact;
    }
    function syncOptionState(choices) {
      optionControls.forEach((control) => {
        const index = Number(control.dataset.cpOptionIndex);
        const candidates = variants.filter((candidate) => candidate.options[index] === control.value && candidate.options.every((value, position) => position >= index || value === choices[position]));
        control.disabled = !candidates.some((candidate) => candidate.available);
        if (index !== 0) return;
        const label = section.querySelector(`label[for="${control.id}"]`);
        if (!label) return;
        const candidate = candidates.find((item) => item.available && item.options.every((value, position) => position === 0 || value === choices[position])) || candidates.find((item) => item.available) || candidates[0];
        if (!candidate) return;
        const cardPrice = label.querySelector('.cp-size-card__price');
        const unitPrice = label.querySelector('.cp-size-card__unit');
        const grams = Number(label.dataset.cpWeightGrams);
        if (cardPrice) cardPrice.textContent = money(candidate.price);
        if (unitPrice && grams > 0) unitPrice.textContent = `(${money(Math.round(candidate.price * 100 / grams))}/100g)`;
      });
    }
    function updateVariant(event) {
      let choices = readChoices();
      const variant = variantForChoices(choices, Number(event?.target?.dataset.cpOptionIndex));
      if (variant) {
        choices = variant.options;
        optionControls.forEach((control) => {
          const value = choices[Number(control.dataset.cpOptionIndex)];
          if (control.type === 'radio') control.checked = control.value === value;
          else control.value = value;
        });
      }
      syncOptionState(choices);
      const id = section.querySelector('[data-cp-variant-id]');
      const price = section.querySelector('[data-cp-price]');
      const stock = section.querySelector('[data-cp-stock]');
      const sku = section.querySelector('[data-cp-sku]');
      const button = section.querySelector('[data-cp-add]');
      const stickyButton = section.querySelector('[data-cp-sticky-add]');
      if (!variant) {
        if (id) id.value = '';
        if (price) price.textContent = '—';
        if (stock) { stock.textContent = section.dataset.cpUnavailable || 'Unavailable'; stock.classList.add('is-unavailable'); }
        if (sku) sku.hidden = true;
        [button, stickyButton].filter(Boolean).forEach((target) => { target.disabled = true; target.textContent = section.dataset.cpUnavailable || 'Unavailable'; });
        const url = new URL(window.location.href);
        url.searchParams.delete('variant');
        window.history.replaceState({}, '', url);
        return;
      }
      if (id) id.value = variant.id;
      if (price) price.textContent = money(variant.price);
      if (stock) {
        stock.innerHTML = `<span aria-hidden="true">●</span> ${variant.available ? 'In stock' : 'Out of stock'}`;
        stock.classList.toggle('is-unavailable', !variant.available);
      }
      if (sku) {
        sku.hidden = !variant.sku;
        const value = sku.querySelector('span');
        if (value) value.textContent = variant.sku || '';
      }
      if (button) { button.disabled = !variant.available; button.textContent = variant.available ? 'Add to bag' : 'Sold out'; }
      if (stickyButton) { stickyButton.disabled = !variant.available; stickyButton.textContent = variant.available ? 'Add to bag' : 'Sold out'; }
      const mediaId = String(variant.featured_media?.id || variant.featured_image?.id || '');
      let imageIndex = mediaId ? thumbs.findIndex((thumb) => thumb.dataset.cpMediaId === mediaId) : -1;
      if (imageIndex < 0 && variant.featured_image?.src) {
        const imageName = (url) => String(url || '').split('?')[0].split('/').pop().replace(/_\d+x\d*(?=\.[^.]+$)/, '');
        const variantImageName = imageName(variant.featured_image.src);
        imageIndex = thumbs.findIndex((thumb) => imageName(thumb.dataset.cpImage) === variantImageName);
      }
      if (imageIndex < 0 && !variant.featured_image?.src && choices[0]) {
        const size = choices[0].replace(/\s/g, '').toLowerCase();
        imageIndex = thumbs.findIndex((thumb) => (thumb.dataset.cpAlt || '').replace(/\s/g, '').toLowerCase().includes(size));
      }
      if (imageIndex >= 0) showImage(imageIndex);
      else if (variant.featured_image?.src && image) {
        image.removeAttribute('srcset'); image.removeAttribute('sizes'); image.src = variant.featured_image.src;
        image.alt = `${section.querySelector('h1')?.textContent || 'Product'} ${choices.join(' ')}`;
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }
    optionControls.forEach((control) => control.addEventListener('change', updateVariant));
    updateVariant();
    section.querySelector('.cp-form')?.addEventListener('submit', (event) => {
      const id = section.querySelector('[data-cp-variant-id]')?.value;
      const selected = variants.find((candidate) => String(candidate.id) === String(id));
      if (!selected?.available) event.preventDefault();
    });

    const mainQuantity = section.querySelector('.cp-form .cp-quantity input[name="quantity"]');
    const stickyQuantity = section.querySelector('[data-cp-sticky-quantity]');
    const mainAddButton = section.querySelector('[data-cp-add]');
    const stickyAddButton = section.querySelector('[data-cp-sticky-add]');
    const syncStickyQuantity = () => {
      if (mainQuantity && stickyQuantity) stickyQuantity.textContent = String(Math.max(Number(mainQuantity.min) || 1, parseInt(mainQuantity.value, 10) || 1));
    };
    mainQuantity?.addEventListener('input', syncStickyQuantity);
    mainQuantity?.addEventListener('change', syncStickyQuantity);
    section.querySelectorAll('[data-cp-sticky-qty]').forEach((control) => control.addEventListener('click', () => {
      if (!mainQuantity) return;
      const minimum = Number(mainQuantity.min) || 1;
      const maximum = mainQuantity.max ? Number(mainQuantity.max) : Infinity;
      mainQuantity.value = String(Math.min(maximum, Math.max(minimum, (parseInt(mainQuantity.value, 10) || minimum) + Number(control.dataset.cpStickyQty))));
      mainQuantity.dispatchEvent(new Event('input', { bubbles: true }));
      mainQuantity.dispatchEvent(new Event('change', { bubbles: true }));
    }));
    stickyAddButton?.addEventListener('click', () => {
      if (!stickyAddButton.disabled) mainAddButton?.click();
    });
    syncStickyQuantity();

    const details = section.querySelector('[data-cp-description]');
    const intro = section.querySelector('[data-cp-intro]');
    const introText = section.querySelector('[data-cp-intro-text]');
    if (details && intro && introText) {
      const firstParagraph = details.querySelector('p');
      if (firstParagraph) {
        introText.textContent = firstParagraph.textContent.trim();
        firstParagraph.remove();
      }
    }
    const readMore = section.querySelector('[data-cp-read-more]');
    readMore?.addEventListener('click', () => {
      const isOpen = intro.classList.toggle('is-open');
      readMore.textContent = isOpen ? 'Read less' : 'Read more';
      readMore.setAttribute('aria-expanded', String(isOpen));
    });

    const accordion = section.querySelector('[data-cp-accordion]');
    if (details && accordion) {
      const headings = [...details.querySelectorAll('h5')];
      const groups = [];
      if (headings.length) {
        const beforeFirst = document.createRange();
        beforeFirst.setStart(details, 0);
        beforeFirst.setEndBefore(headings[0]);
        groups.push({ title: 'Product details', nodes: [...beforeFirst.cloneContents().childNodes] });
        headings.forEach((heading, index) => {
          const content = document.createRange();
          content.setStartAfter(heading);
          if (headings[index + 1]) content.setEndBefore(headings[index + 1]);
          else content.setEnd(details, details.childNodes.length);
          groups.push({ title: heading.textContent.replace(/\s+/g, ' ').trim(), nodes: [...content.cloneContents().childNodes] });
        });
      } else groups.push({ title: 'Product details', nodes: [...details.childNodes] });
      if (groups.length > 1) {
        details.replaceChildren(...groups[0].nodes);
        groups.slice(1).forEach((item, index) => {
          if (!item.title) return;
          const existing = [...accordion.querySelectorAll('.cp-accordion__trigger')].find((trigger) => trigger.querySelector('span')?.textContent.trim().toLowerCase() === item.title.toLowerCase());
          if (existing) {
            const existingPanel = accordion.querySelector(`#${existing.getAttribute('aria-controls')}`);
            if (existingPanel) existingPanel.append(...item.nodes);
            return;
          }
          const base = `cp-auto-accordion-${section.dataset.sectionId}-${index}`;
          const wrapper = document.createElement('div');
          wrapper.className = 'cp-accordion__item';
          const heading = document.createElement('h2');
          heading.className = 'cp-accordion__heading';
          const button = document.createElement('button');
          button.type = 'button'; button.className = 'cp-accordion__trigger'; button.id = `${base}-button`; button.setAttribute('aria-controls', base); button.setAttribute('aria-expanded', 'false');
          const label = document.createElement('span'); label.textContent = item.title;
          const symbol = document.createElement('span'); symbol.className = 'cp-accordion__symbol'; symbol.setAttribute('aria-hidden', 'true');
          button.append(label, symbol); heading.append(button);
          const panel = document.createElement('div');
          panel.role = 'region'; panel.id = base; panel.className = 'cp-accordion__panel rte'; panel.hidden = true; panel.setAttribute('aria-labelledby', button.id); panel.append(...item.nodes);
          wrapper.append(heading, panel); accordion.append(wrapper);
        });
      }
      accordion.querySelectorAll('.cp-accordion__trigger').forEach((trigger) => {
        trigger.addEventListener('click', () => {
          const panel = accordion.querySelector(`#${trigger.getAttribute('aria-controls')}`);
          const item = trigger.closest('.cp-accordion__item');
          const open = trigger.getAttribute('aria-expanded') !== 'true';
          if (open) {
            accordion.querySelectorAll('.cp-accordion__trigger[aria-expanded="true"]').forEach((otherTrigger) => {
              if (otherTrigger === trigger) return;
              const otherPanel = accordion.querySelector(`#${otherTrigger.getAttribute('aria-controls')}`);
              otherTrigger.setAttribute('aria-expanded', 'false');
              if (otherPanel) otherPanel.hidden = true;
              otherTrigger.closest('.cp-accordion__item')?.classList.remove('is-open');
            });
          }
          trigger.setAttribute('aria-expanded', String(open));
          if (panel) panel.hidden = !open;
          item?.classList.toggle('is-open', open);
        });
      });

      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        accordion.querySelectorAll('.cp-accordion__item').forEach((item) => {
          const trigger = item.querySelector('.cp-accordion__trigger');
          let hoverTimer;
          item.addEventListener('mouseenter', () => {
            window.clearTimeout(hoverTimer);
            hoverTimer = window.setTimeout(() => {
              if (trigger?.getAttribute('aria-expanded') !== 'true') trigger?.click();
            }, 90);
          });
          item.addEventListener('mouseleave', () => {
            window.clearTimeout(hoverTimer);
            hoverTimer = window.setTimeout(() => {
              if (trigger?.getAttribute('aria-expanded') === 'true') trigger?.click();
            }, 140);
          });
        });
      }
    }

    const faqCard = section.querySelector('.cp-faq-card');
    if (faqCard && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      const faqItems = [...faqCard.querySelectorAll('details')];
      faqItems.forEach((item) => {
        let hoverTimer;
        item.addEventListener('mouseenter', () => {
          window.clearTimeout(hoverTimer);
          hoverTimer = window.setTimeout(() => {
            faqItems.forEach((other) => { if (other !== item) other.open = false; });
            item.open = true;
          }, 90);
        });
        item.addEventListener('mouseleave', () => {
          window.clearTimeout(hoverTimer);
          hoverTimer = window.setTimeout(() => { item.open = false; }, 140);
        });
      });
    }

    const recommendationSections = [...section.querySelectorAll('[data-cp-recommendations]')];
    const relatedCard = section.querySelector('[data-cp-related-card]');
    const relatedSlot = section.querySelector('[data-cp-related-slot]');
    const sameCollectionRecommendations = recommendationSections.find((item) => !item.matches('[data-randomize="true"]'));
    if (relatedSlot && sameCollectionRecommendations) {
      sameCollectionRecommendations.classList.add('is-compact');
      relatedSlot.append(sameCollectionRecommendations);
    } else if (relatedCard) relatedCard.hidden = true;

    recommendationSections.forEach((recommendations) => {
      const recommendationTrack = recommendations.querySelector('[data-cp-recommendation-track]');
      const recommendationCounter = recommendations.querySelector('[data-cp-recommendation-counter]');
      if (!recommendationTrack) return;
      if (recommendations.matches('[data-randomize="true"]')) {
        const shuffled = [...recommendationTrack.children];
        for (let index = shuffled.length - 1; index > 0; index -= 1) {
          const swap = Math.floor(Math.random() * (index + 1));
          [shuffled[index], shuffled[swap]] = [shuffled[swap], shuffled[index]];
        }
        recommendationTrack.append(...shuffled);
      }
      const cards = [...recommendationTrack.querySelectorAll('.cp-recommendation')];
      const updateRecommendationCounter = () => {
        if (!recommendationCounter || !cards.length) return;
        const styles = getComputedStyle(recommendationTrack);
        const gap = parseFloat(styles.columnGap || styles.gap) || 0;
        const columnsPassed = Math.round(recommendationTrack.scrollLeft / ((cards[0]?.offsetWidth || recommendationTrack.clientWidth) + gap));
        const visible = Math.max(1, Math.round((recommendationTrack.clientWidth + gap) / ((cards[0]?.offsetWidth || recommendationTrack.clientWidth) + gap)));
        const start = Math.min(cards.length, columnsPassed + 1);
        recommendationCounter.textContent = `${start}–${Math.min(cards.length, start + visible - 1)} of ${cards.length}`;
      };
      const moveRecommendations = (direction) => {
        const maximum = recommendationTrack.scrollWidth - recommendationTrack.clientWidth;
        const atEnd = recommendationTrack.scrollLeft >= maximum - 4;
        const atStart = recommendationTrack.scrollLeft <= 4;
        if ((direction > 0 && atEnd) || (direction < 0 && atStart)) recommendationTrack.scrollTo({ left: direction > 0 ? 0 : maximum, behavior: 'smooth' });
        else {
          const styles = getComputedStyle(recommendationTrack);
          const gap = parseFloat(styles.columnGap || styles.gap) || 0;
          const step = (cards[0]?.offsetWidth || recommendationTrack.clientWidth) + gap;
          recommendationTrack.scrollBy({ left: direction * step, behavior: 'smooth' });
        }
      };
      recommendations.querySelectorAll('[data-cp-recommendation-step]').forEach((button) => button.addEventListener('click', () => moveRecommendations(Number(button.dataset.cpRecommendationStep))));
      recommendationTrack.addEventListener('scroll', updateRecommendationCounter, { passive: true });
      window.addEventListener('resize', updateRecommendationCounter, { passive: true });
      let paused = false;
      recommendations.addEventListener('mouseenter', () => { paused = true; });
      recommendations.addEventListener('mouseleave', () => { paused = false; });
      recommendations.addEventListener('focusin', () => { paused = true; });
      recommendations.addEventListener('focusout', () => { paused = false; });
      if (cards.length > 4 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        window.setInterval(() => { if (!paused && !document.hidden && document.body.contains(recommendations)) moveRecommendations(1); }, 4000);
      }
      updateRecommendationCounter();
    });

  }

  function init(root = document) {
    if (root.matches?.('[data-cp-product]')) setupProduct(root);
    root.querySelectorAll('[data-cp-product]').forEach(setupProduct);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
